import { Axios } from "../constants/api";

export const getTranslations = (locale: string) => {
  return Axios.get(`/translations/?lang=${locale}`);
};
